<template>
    <div class="hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10">
        <div class="grid grid-rows-8 h-full">
            <MenuButton :to="{name:'Home', params: {id}}" icon-class="icon-home" tooltip="Home"></MenuButton>
            <div class="flex-grow grid grid-rows-8 row-span-8">
                <MenuButton :to="{name:'DettaglioSottoProgetto', params: {id}}" icon-class="icon-catena_verticale" tooltip="Sottprogetto"></MenuButton>
                <MenuButton :to="{name:'SottoProgettoListaFornitori', params: {id}}" icon-class="icon-documento_freccia" tooltip="ODA"></MenuButton>
                <MenuButton :to="{name:'SottoProgettoODV', params: {id}}" icon-class="icon-documento_freccia rotate-180" tooltip="ODV"></MenuButton>
                <MenuButton :to="{name:'SottoProgettoPianoFatturazione', params: {id}}" icon-class="icon-euro_frecce" tooltip="Piano Fatturazione"></MenuButton>
                <MenuButton :to="{name:'VersioniSottoProgetto', params: {id}}" icon-class="icon-orologio_freccia" tooltip="Versioni"></MenuButton>
                <MenuButton :to="{name:'SottoprogettoCostiRicavi', params: {id}}" icon-class="icon-opzioni" tooltip="Costi/Ricavi"></MenuButton>
                <MenuButton :to="{name:'SottoprogettoDocumentiFornitori', params: {id}}" icon-class="icon-graffetta" tooltip="Documenti fornitori"></MenuButton>
                <ProfileMenuButton class="row-start-8" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import MenuButton from "@/components/MenuButton.vue";
import ProfileMenuButton from "@/components/ProfileMenuButton.vue";
import { mapGetters } from 'vuex';
import SottoProgettoODV from "@/views/SottoProgettoODV.vue";

@Options({
    name:'SottoProgettiMenu',
    components:{
        MenuButton,
        ProfileMenuButton
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        id: String,
    },
    computed: {
        ...mapGetters([
            'meCounters',
        ]),
    },
})
export default class SottoProgettiMenu extends Vue {
    private $store: any;

    toggle() {
        this.$store.commit('toggle_menu')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
